let config = require('./config');
/**
 * @constructor
 */
class LoginComponent {
    constructor() {
        this.loginurl = config.api.protocol +  config.api.url;
        this.loginElement = $('.goToBizXpert');
        this.registerLoginEvent();

        //show android and ios app lunch tracker
        this.$playStoreBtn = $('.playstore');
        this.showplayStore();

        this.$appleStoreBtn = $('.iosstore');
        this.showAppleStore();
    }

    registerLoginEvent() {
        var that = this;
        this.loginElement.on('click', function () {
            location.href = that.loginurl;
        });
    }

    showplayStore() {
        this.$playStoreBtn.on('click', function () {
            location.href = 'https://play.google.com/store/apps/details?id=com.bizxpert.andoridhu'
        });
    }

    showAppleStore() {
        this.$appleStoreBtn.on('click', function () {
            location.href = 'https://itunes.apple.com/hu/app/bizxpert-sz%C3%A1ml%C3%A1z%C3%B3/id1367906719?mt=8'
        });
    }
}

var p = new LoginComponent();